module.exports = __webpack_public_path__ + "img/product-1.57bf5473.png";